import React from 'react';
import { Box, Tab, Tabs } from '@mui/material';
import { FinancialPeriodFilter } from './FinancialPeriodFilter';
import { DashboardTabPanel } from './DashboardTabPanel';
import { OverviewTabMobile } from './tabs/OverviewTabMobile';
import { CategoriesTab } from './tabs/CategoriesTab';
import { GoalsTabMobile } from './tabs/GoalsTabMobile';
import { dashboardTabs, useFinancialDashboardScreen } from './hooks/useFinancialDashboardScreen';

export default function FinancialDashboardMobile() {
  const {
    period,
    selectedDate,
    setSelectedDate,
    viewByYear,
    setViewByYear,
    viewAllPeriod,
    setViewAllPeriod,
    activeTab,
    changeTab,
  } = useFinancialDashboardScreen();

  return (
    <Box sx={{ pb: 2 }}>
      <FinancialPeriodFilter
        selectedDate={selectedDate}
        onChange={setSelectedDate}
        viewByYear={viewByYear}
        onToggleViewByYear={setViewByYear}
        viewAllPeriod={viewAllPeriod}
        onToggleViewAllPeriod={setViewAllPeriod}
      />

      <Tabs
        value={activeTab}
        onChange={(_, tab) => changeTab(tab)}
        variant="scrollable"
        scrollButtons="auto"
        allowScrollButtonsMobile
        sx={{ mt: 2, borderBottom: 1, borderColor: 'divider' }}
      >
        <Tab label="Visão Geral" value={dashboardTabs.OVERVIEW} />
        <Tab label="Categorias" value={dashboardTabs.CATEGORIES} />
        <Tab label="Metas" value={dashboardTabs.GOALS} />
      </Tabs>

      <DashboardTabPanel index={dashboardTabs.OVERVIEW} activeTab={activeTab}>
        <OverviewTabMobile period={period} />
      </DashboardTabPanel>

      <DashboardTabPanel index={dashboardTabs.CATEGORIES} activeTab={activeTab}>
        <CategoriesTab period={period} />
      </DashboardTabPanel>

      <DashboardTabPanel index={dashboardTabs.GOALS} activeTab={activeTab}>
        <GoalsTabMobile period={period} />
      </DashboardTabPanel>
    </Box>
  );
}
